(() => {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = (n) => String(n).padStart(2, '0');
  const left = (end) => {
    const ms = Date.parse(end) - Date.now();
    if (!(ms > 0)) return null;
    const s = Math.floor(ms / 1000);
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  };
  // countdowns: [data-mk-countdown="ISO"] with a [data-mk-left] child
  const cds = [...d.querySelectorAll('[data-mk-countdown]')];
  const tick = () => {
    cds.forEach((el) => {
      const t = left(el.dataset.mkCountdown);
      if (!t) { el.hidden = true; return; }
      const out = el.querySelector('[data-mk-left]');
      if (out) out.textContent = `${t.d}d ${pad(t.h)}h ${pad(t.m)}m${el.dataset.mkSeconds ? ` ${pad(t.s)}s` : ''}`;
      el.hidden = false;
    });
  };
  if (cds.length) { tick(); setInterval(tick, 1000); }
  // announcement rotation
  d.querySelectorAll('[data-mk-rotate]').forEach((bar) => {
    const msgs = [...bar.querySelectorAll('.mk-announce-msg')].filter((m) => !m.hidden);
    if (msgs.length < 2 || reduce) return;
    let i = 0;
    setInterval(() => { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 5000);
  });
  // delivery estimate: [data-mk-eta="min,max"]
  const addBiz = (n) => { const x = new Date(); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w && w < 6) k++; } return x; };
  const fmt = (x) => x.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const addCal = (n) => { const x = new Date(); x.setDate(x.getDate() + n); return x; };
  const fmtd = (x) => x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  d.querySelectorAll('[data-mk-eta]').forEach((el) => {
    const [a, b] = el.dataset.mkEta.split(',').map(Number);
    const out = el.querySelector('[data-mk-dates]');
    if (out && a && b) out.textContent = 'mkCal' in el.dataset ? `between ${fmtd(addCal(a))} and ${fmtd(addCal(b))}` : `${fmt(addBiz(a))} and ${fmt(addBiz(b))}`;
  });
  // lazy loop videos: <video data-mk-src>
  const vids = [...d.querySelectorAll('video[data-mk-src]')];
  const start = (v) => { if (!v.src) { v.src = v.dataset.mkSrc; v.load(); } const p = v.play(); if (p) p.catch(() => {}); };
  if (!reduce && vids.length) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? start(e.target) : e.target.src && e.target.pause())), { rootMargin: '200px 0px' });
      vids.forEach((v) => (v.dataset.mkEager ? start(v) : io.observe(v)));
    } else vids.forEach(start);
  }
  // recline diagram
  d.querySelectorAll('[data-mk-recline]').forEach((box) => {
    const back = box.querySelector('.mk-recline-back');
    const legs = box.querySelector('.mk-recline-legs');
    const note = box.querySelector('[data-mk-note]');
    box.querySelectorAll('.mk-chip').forEach((chip) => chip.addEventListener('click', () => {
      box.querySelectorAll('.mk-chip').forEach((c) => { c.classList.toggle('is-on', c === chip); c.setAttribute('aria-pressed', c === chip); });
      const b = Number(chip.dataset.back), l = Number(chip.dataset.legs);
      if (back) back.style.transform = `rotate(${-b}deg)`;
      if (legs) legs.style.transform = `rotate(${-l * 1.4}deg)`;
      if (note) note.innerHTML = `<strong>${chip.textContent.trim()}.</strong> ${chip.dataset.note}`;
    }));
  });
  // copy code buttons
  d.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mk-copy]');
    if (!btn) return;
    const code = btn.dataset.mkCopy;
    (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(() => { btn.dataset.label = btn.textContent; btn.textContent = 'Copied'; setTimeout(() => (btn.textContent = btn.dataset.label), 1800); }).catch(() => {});
  });
  // sticky add to cart
  const bar = d.querySelector('[data-mk-sticky]');
  const buy = d.querySelector('product-info .product-form__buttons, .product-form__buttons');
  if (bar && buy && 'IntersectionObserver' in window) {
    // phones: the bar shows whenever the buy buttons are off screen, above or below; larger screens: only once scrolled past them
    const phone = window.matchMedia('(max-width: 749px)');
    new IntersectionObserver(([e]) => { const on = !e.isIntersecting && (phone.matches || e.boundingClientRect.top < 0); bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on); }, { rootMargin: '0px 0px -72px 0px' }).observe(buy);
    bar.querySelector('[data-mk-sticky-add]').addEventListener('click', () => {
      const submit = d.querySelector('product-info .product-form__submit, .product-form__submit');
      if (submit && !submit.disabled) submit.click(); else buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    const sync = () => {
      const sel = d.querySelector('product-info .product-form__input input:checked');
      const v = bar.querySelector('[data-mk-sticky-variant]');
      if (v && sel) v.textContent = sel.value;
      const pr = d.querySelector('product-info .price .price-item--sale, product-info .price .price-item--regular');
      const tgt = bar.querySelector('[data-mk-sticky-price]');
      if (pr && tgt) tgt.textContent = pr.textContent.trim();
    };
    d.addEventListener('change', (e) => { if (e.target.closest('variant-selects')) setTimeout(sync, 300); });
    sync();
  }
  // price inside the add to cart button follows the selected variant
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
      const sid = ev && ev.data && ev.data.sectionId;
      const html = ev && ev.data && ev.data.html;
      if (!sid || !html || !html.querySelector) return;
      const fresh = html.querySelector(`#ProductSubmitButton-${sid} .mk-atc-price`);
      const cur = d.querySelector(`#ProductSubmitButton-${sid} .mk-atc-price`);
      if (fresh && cur) cur.textContent = fresh.textContent;
      const lp = d.querySelector('.mk-life-price');
      if (fresh && lp) lp.textContent = fresh.textContent;
    });
  }
  // buttons outside the buy box: add the selected variant to the cart
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mk-buy]');
    if (b) {
      const submit = d.querySelector('product-info .product-form__submit, .product-form__submit');
      if (submit && !submit.disabled) submit.click();
      else if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    // color cards: select the color in the buy box without reloading
    const a = e.target.closest('[data-mk-pick]');
    if (!a) return;
    const input = [...d.querySelectorAll('product-info variant-selects input[type="radio"]')].find((i) => i.value === a.dataset.mkPick);
    if (!input) return;
    e.preventDefault();
    input.click();
    d.querySelectorAll('[data-mk-pick]').forEach((x) => {
      const on = x === a;
      x.classList.toggle('is-on', on);
      if (on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current');
      const cta = x.querySelector('.mk-color-cta');
      if (cta && (on || cta.textContent.trim() === x.dataset.selected)) cta.textContent = on ? x.dataset.selected : x.dataset.choose;
    });
    const top = d.querySelector('product-info');
    if (top) top.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
  // photo gallery: tap or click a photo to see it larger
  const gals = [...d.querySelectorAll('.mk-gal')];
  if (gals.length) {
    const ic = (p) => `<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="${p}" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    let lb = null, pic = null, count = null, list = [], at = 0, back = null;
    const big = (img) => (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=1600');
    const show = (i) => {
      at = (i + list.length) % list.length;
      pic.src = big(list[at]);
      pic.alt = list[at].alt || '';
      count.textContent = `${at + 1} / ${list.length}`;
    };
    const close = () => {
      lb.hidden = true;
      d.documentElement.classList.remove('mk-lb-open');
      if (back) back.focus({ preventScroll: true });
    };
    const build = () => {
      const st = d.createElement('style');
      st.textContent = '.mk-gal-item img{cursor:zoom-in}html.mk-lb-open{overflow:hidden}'
        + '.mk-lb{position:fixed;inset:0;z-index:1001;display:flex;align-items:center;justify-content:center;padding:64px 72px;background:rgba(28,22,18,.94)}'
        + '.mk-lb[hidden]{display:none}'
        + '.mk-lb img{display:block;max-width:min(100%,1100px);max-height:100%;width:auto;height:auto;border-radius:16px;object-fit:contain}'
        + '.mk-lb button{position:absolute;display:grid;place-items:center;width:46px;height:46px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;cursor:pointer}'
        + '.mk-lb button:hover{background:rgba(255,255,255,.26)}'
        + '.mk-lb-x{top:12px;right:12px}.mk-lb-nav{top:50%;transform:translateY(-50%)}.mk-lb-prev{left:14px}.mk-lb-next{right:14px}'
        + '.mk-lb-count{position:absolute;left:0;right:0;bottom:22px;margin:0;text-align:center;color:rgba(255,255,255,.8);font-size:1.4rem;letter-spacing:.06em}'
        + '@media (max-width:749px){.mk-lb{padding:64px 10px 84px}.mk-lb-nav{top:auto;bottom:12px;transform:none}.mk-lb-prev{left:calc(50% - 104px)}.mk-lb-next{right:calc(50% - 104px)}}';
      d.head.appendChild(st);
      lb = d.createElement('div');
      lb.className = 'mk-lb';
      lb.hidden = true;
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Photo viewer');
      lb.innerHTML = `<img alt=""><button type="button" class="mk-lb-x" data-lb-close aria-label="Close">${ic('M6 6l12 12M18 6L6 18')}</button>`
        + `<button type="button" class="mk-lb-nav mk-lb-prev" data-lb-prev aria-label="Previous photo">${ic('M15 5l-7 7 7 7')}</button>`
        + `<button type="button" class="mk-lb-nav mk-lb-next" data-lb-next aria-label="Next photo">${ic('M9 5l7 7-7 7')}</button><p class="mk-lb-count"></p>`;
      d.body.appendChild(lb);
      pic = lb.querySelector('img');
      count = lb.querySelector('.mk-lb-count');
      lb.addEventListener('click', (e) => {
        if (e.target.closest('[data-lb-prev]')) show(at - 1);
        else if (e.target.closest('[data-lb-next]')) show(at + 1);
        else if (e.target === lb || e.target.closest('[data-lb-close]')) close();
      });
      d.addEventListener('keydown', (e) => {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(at - 1);
        else if (e.key === 'ArrowRight') show(at + 1);
        else if (e.key === 'Tab') { const f = [...lb.querySelectorAll('button')]; const i = f.indexOf(d.activeElement); e.preventDefault(); f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus(); }
      });
      let x0 = null;
      lb.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1));
      }, { passive: true });
    };
    const open = (g, img) => {
      if (!lb) build();
      list = [...g.querySelectorAll('.mk-gal-set:not([aria-hidden]) .mk-gal-item img')];
      const li = img.closest('.mk-gal-item');
      const i = [...li.parentNode.children].indexOf(li);
      if (!list.length) return;
      back = img;
      show(i < 0 ? 0 : i);
      lb.hidden = false;
      d.documentElement.classList.add('mk-lb-open');
      lb.querySelector('[data-lb-close]').focus({ preventScroll: true });
    };
    gals.forEach((g) => {
      g.querySelectorAll('.mk-gal-set:not([aria-hidden]) .mk-gal-item img').forEach((img) => {
        img.tabIndex = 0;
        img.setAttribute('role', 'button');
        img.setAttribute('aria-label', `View larger: ${img.alt || 'photo'}`);
      });
      g.addEventListener('click', (e) => {
        const img = e.target.closest('.mk-gal-item img');
        if (img) open(g, img);
      });
      g.addEventListener('keydown', (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.mk-gal-item img')) { e.preventDefault(); open(g, e.target); }
      });
    });
  }
  // klaviyo onsite (forms + tracking) when the app embed is not enabled
  window.addEventListener('load', () => {
    if (window._klOnsite || d.querySelector('script[src*="static.klaviyo.com/onsite/js"]')) return;
    const k = d.createElement('script');
    k.async = true;
    k.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Rnt45a';
    d.body.appendChild(k);
  });
})();
